import type { ReactNode } from "react";

export function Eyebrow({ children, tone = "light" }: { children: ReactNode; tone?: "light" | "dark" }) {
  return (
    <span
      className={
        "inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-widest uppercase " +
        (tone === "dark" ? "text-accent-300" : "text-primary-600")
      }
    >
      <span className={"h-px w-6 " + (tone === "dark" ? "bg-accent-400" : "bg-primary-500")} />
      {children}
    </span>
  );
}

export function SectionHead({
  eyebrow,
  title,
  desc,
  center = false,
  tone = "light",
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
  tone?: "light" | "dark";
}) {
  return (
    <div className={center ? "text-center flex flex-col items-center" : ""}>
      <Eyebrow tone={tone}>{eyebrow}</Eyebrow>
      <h2
        className={
          "mt-3 text-2xl md:text-4xl font-bold leading-snug tracking-tight " +
          (tone === "dark" ? "text-background-50" : "text-foreground-950")
        }
      >
        {title}
      </h2>
      {desc ? (
        <p
          className={
            "mt-3 max-w-2xl text-sm md:text-base leading-relaxed " +
            (tone === "dark" ? "text-background-200/80" : "text-foreground-600")
          }
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}

export function MetaItem({ icon, children, tone = "light" }: { icon: string; children: ReactNode; tone?: "light" | "dark" }) {
  return (
    <span className={"inline-flex items-center gap-1.5 " + (tone === "dark" ? "text-background-200/70" : "text-foreground-500")}>
      <i className={icon} />
      <span className="whitespace-nowrap text-xs">{children}</span>
    </span>
  );
}